import React, { SyntheticEvent, useState } from 'react';
import classNames from 'classnames';

import ExternalLink from 'src/components/common/external-link';
import IconButton from 'src/components/ui/icon-button';
import { ReactComponent as ArrowIcon } from 'src/assets/icons/arrow.svg';
import { ReactComponent as FacebookSmallLogo } from 'src/assets/icons/logo-fb-small.svg';

import { LIST_REVIEWS } from 'src/constants';
import { createNumberedArray } from 'src/utils';

import './reviews.scss';

const getTabIndex = (index: number) => {
  if ([1, 2, 3].includes(index)) {
    return 0;
  }

  return -1;
};

const Reviews = () => {
  const [orderItems, setOrderItems] = useState(() => createNumberedArray(LIST_REVIEWS.length));
  const [direction, setDirection] = useState<'next' | 'prev' | ''>('');

  const onNextButtonClick = (e: SyntheticEvent) => {
    e.preventDefault();
    if (direction) {
      return;
    }

    setDirection('next');
    setOrderItems((prevOrderItems) => {
      const orderItems = [...prevOrderItems];
      orderItems.unshift(orderItems.pop()!);
      return orderItems;
    });
  };

  const onPrevButtonClick = (e: SyntheticEvent) => {
    e.preventDefault();
    if (direction) {
      return;
    }

    setDirection('prev');

    setOrderItems((prevOrderItems) => {
      const orderItems = [...prevOrderItems];
      orderItems.push(orderItems.shift()!);
      return orderItems;
    });
  };

  const handleTransitionEnd = () => {
    setDirection('');
  };

  return (
    <section className="reviews">
      <h2 className="reviews__title">ביקורות על העבודה שלנו</h2>
      <div className="reviews__slider">
        <IconButton
          ariaLabel="מַהֲלָך הקודם"
          className="reviews__button reviews__button_prev"
          icon={<ArrowIcon className="reviews__button-icon" />}
          size="oversize"
          onClick={onPrevButtonClick}
        />

        <IconButton
          ariaLabel="מַהֲלָך הבא"
          className="reviews__button reviews__button_next"
          icon={<ArrowIcon className="reviews__button-icon" />}
          size="oversize"
          onClick={onNextButtonClick}
        />

        <div className="reviews__items-wrapper">
          <div
            className={classNames(
              'reviews__items',
              direction && `reviews__items_move-${direction}`
            )}
            onTransitionEnd={handleTransitionEnd}
          >
            {LIST_REVIEWS.map(({ title, text, link }, index) => (
              <div
                className={`reviews__item reviews__item_${orderItems[index]}`}
                key={`review_item_${index}`}
              >
                <div className="reviews__item-content">
                  <span className="reviews__item-name">{title}</span>
                  <span className="reviews__item-text">{text}</span>
                  {link && (
                    <ExternalLink
                      className="reviews__item-link"
                      href={link}
                      tabIndex={getTabIndex(orderItems[index])}
                    >
                      <FacebookSmallLogo />
                      <span>המלצה הועתקה מעמוד הפייסבוק שלנו</span>
                    </ExternalLink>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
